// @ts-check
import { z } from 'zod';

import GlobalMeta from '@/store/modules/models/global/Meta';

import { Envelope } from '@/store/modules/envelopes/models/Envelope';

const Meta = GlobalMeta.extend({
  aggregates: z.record(Envelope.shape.status, z.number()),
});

export default Meta;

/** @typedef {z.infer<typeof Meta>} TMeta */
